import { render, staticRenderFns } from "./IconReservations.vue?vue&type=template&id=29da8cf6"
import script from "./IconReservations.vue?vue&type=script&lang=js"
export * from "./IconReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports